module.exports = __webpack_public_path__ + "img/check-white.3dba18d5.svg";